import QRCodeScanner from "../helpers/QRCodeScanner";

import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";

import {
  QR_START_SCANNING,
  QR_STOP_SCANNING,
  QR_NEW_STATUS,
  QR_TURN_LIGHT_ON,
  QR_TURN_LIGHT_OFF,
  QR_USE_BACK_CAMERA,
  QR_USE_FRONT_CAMERA,
  QR_CODE_RECOGNIZED,
  QR_ERROR
} from "./messageTypes";

const theQRCodeScanner = new QRCodeScanner();

function onCodeRecognized(code) {
  sendMessageToWebApp(QR_CODE_RECOGNIZED, { code });
}

if (theQRCodeScanner.haveScanner) {
  theQRCodeScanner.onStatusUpdate(newStatus => {
    sendMessageToWebApp(QR_NEW_STATUS, newStatus);
  });

  onMessageFromWebApp(QR_TURN_LIGHT_ON, async () => {
    try {
      await theQRCodeScanner.enableLight();
      await theQRCodeScanner.startScanning(onCodeRecognized);
    } catch (error) {
      sendMessageToWebApp(QR_ERROR, { error });
    }
  });

  onMessageFromWebApp(QR_TURN_LIGHT_OFF, async () => {
    try {
      await theQRCodeScanner.disableLight();
      await theQRCodeScanner.startScanning(onCodeRecognized);
    } catch (error) {
      sendMessageToWebApp(QR_ERROR, { error });
    }
  });

  onMessageFromWebApp(QR_USE_BACK_CAMERA, async () => {
    try {
      await theQRCodeScanner.useBackCamera();
      await theQRCodeScanner.startScanning(onCodeRecognized);
    } catch (error) {
      sendMessageToWebApp(QR_ERROR, { error });
    }
  });

  onMessageFromWebApp(QR_USE_FRONT_CAMERA, async () => {
    try {
      await theQRCodeScanner.useFrontCamera();
      await theQRCodeScanner.startScanning(onCodeRecognized);
    } catch (error) {
      sendMessageToWebApp(QR_ERROR, { error });
    }
  });

  onMessageFromWebApp(QR_START_SCANNING, async () => {
    try {
      await theQRCodeScanner.startScanning(onCodeRecognized);
    } catch (error) {
      sendMessageToWebApp(QR_ERROR, { error });
    }
  });

  onMessageFromWebApp(QR_STOP_SCANNING, async () => {
    try {
      await theQRCodeScanner.stopScanning();
    } catch (error) {
      sendMessageToWebApp(QR_ERROR, { error });
    }
  });
}
